<!--
  MapLocationDialog.vue
    メンバ位置情報送信Component(webブラウザ)

  @Todo MapLocation.vueを重複する部分が多いので、共通化したい
        （MapLocation.vueをimportしたが地図が表示されなかった）
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <v-dialog
    v-model="mDialog"
    transition="slide-x-transition"
    persistent
  >
    <v-card tile>
      <v-toolbar card dark color="primary">
        <v-btn icon color="primary" @click="onClickClose">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>位置情報送信</v-toolbar-title>
      </v-toolbar>

      <map-area :pmapid="mMapName" ref="mapobj" class="hm-map-area"></map-area>

      <v-layout wrap align-center class="hm-mld-databox">
        <v-flex xs1 text-xs-center>
          <v-btn flat icon large @click="onClickGlIcon">
            <v-icon large color="primary">location_on</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs2>Lat: {{ mGeoLocation.lat }}</v-flex>
        <v-flex xs2>Lon: {{ mGeoLocation.lon }}</v-flex>
        <v-flex xs6>
          <v-form v-model="mMapFormValid">
            <v-textarea
              v-model="mPosMsg"
              :rules="[mPosMsgRules.counter]"
              rows=1
              auto-grow
              label="Memo"
              box
              class="hm-mld-msgbox"
            ></v-textarea>
          </v-form>
        </v-flex>
        <v-flex xs1 text-xs-center>
          <v-btn v-if="mMapFormValid" fab small color="blue lighten-1" @click="onClickSendIcon">
            <v-icon color="white">send</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>

    </v-card>

    <info-dialog-send ref="infoDialogSend">
      <div slot="msg">位置情報を送信しました</div>
    </info-dialog-send>
    <error-dialog-send ref="errorDialogSend">
      <div slot="msg">位置情報の送信に失敗しました</div>
    </error-dialog-send>
    <confirm-dialog ref="confirmDialog">
      <div slot="msg">{{ mConfirmMsg }}</div>
    </confirm-dialog>
    <warning-dialog ref="warningDialog">
      <div slot="msg">{{ mWarningMsg }}</div>
    </warning-dialog>
  </v-dialog>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
import MapOSMOL from '@/components/MapOSMOL'
import MapLocation from '@/components/MapLocation'
import ConfirmDialog from '@/components/dialogs/ConfirmDialog'
import WarningDialog from '@/components/dialogs/WarningDialog'
import ErrorDialog from '@/components/dialogs/ErrorInfoDialog'
import InfoDialog from '@/components/dialogs/SystemInfoDialog'
import { getGeoLocation, getNowDatetimeMoment, formatDateMoment, isNullorUndefined } from '@/common'

export default {
  name: 'MapLocationDialog',
  data: () => ({
    mDialog: false,
    mMapName: 'hm-map-mon',
    mGeoLocation: {
      lat: 'no data',
      lon: 'no data',
    },
    mMapFormValid: true,
    mMapZoom: 15,
    mPosMsg: '',
    mPosMsgRules: {
      counter: v => ((v == null) || (v.length <= 150)) || 'メモ欄は150文字以内で入力してください',
    },
    mGeoErrMsg: '',
    mConfirmMsg: '',
    mWarningMsg: '',
  }),
  components: {
    'map-area': MapOSMOL,
    'map-location': MapLocation,
    'info-dialog-send': InfoDialog,
    'error-dialog-send': ErrorDialog,
    'confirm-dialog': ConfirmDialog,
    'warning-dialog': WarningDialog,
  },
  mounted: function () {
    this.$log.debug('# MapLocationDialog')
    this.$on('showMapLocation', this.show)
  },
  destroyed: function () {
    this.$log.debug('# MapLocationDialog.')
  },
  methods: {
    // -------------------------------------------------------------------------
    show: async function () {
      //this.$store.commit('setIsWhereaboutsPage', false)  // 行動予定一覧の更新を行わない
      this.mDialog = true  // Show Dialog
      this.mPosMsg = ''
      this.mMapFormValid = true
      this.$refs.mapobj.renderMap()
      this.getGeoLocation()
    },
    // -------------------------------------------------------------------------
    onClickClose: function () {
      //this.$store.commit('setIsWhereaboutsPage', true)   // 行動予定一覧の更新を行う
      this.mMapFormValid = true
      this.mDialog = false
      document.getElementById('hm-map-mon').innerHTML = ''
      this.$refs.mapobj.clearMarker()
    },
    // -------------------------------------------------------------------------
    onClickGlIcon: function () {
      this.$refs.mapobj.clearMarker()
      this.getGeoLocation()
    },
    // -------------------------------------------------------------------------
    onClickSendIcon: async function () {
      if (isNullorUndefined(this.$store.getters.loginUserInfo.staff_id) ||
          isNullorUndefined(this.$store.getters.loginUserCompanyId)) {
        this.$log.error('user id or company id is null or undefined.')
        this.$refs.errorDialogSend.$emit('show')
        return
      }

      if (isNullorUndefined(this.mGeoLocation.lat) ||
          this.mGeoLocation.lat === '' ||
          Number.isNaN(Number(this.mGeoLocation.lat))) {
        this.mConfirmMsg = '位置情報が取得できていません。このまま送信してよろしいですか？'
        this.$refs.confirmDialog.$emit('show', this.sendGeoOkCallback)
        return
      }
      this.sendGeoLocation()
    },
    // -------------------------------------------------------------------------
    sendGeoOkCallback: function () {
      this.sendGeoLocation()
    },
    // -------------------------------------------------------------------------
    sendGeoLocation: async function () {
      let send_datetime = formatDateMoment(getNowDatetimeMoment(), 'YYYY-MM-DD HH:mm:ss.SSS')
      let sendData = {
        companyId: this.$store.getters.loginUserCompanyId,
        memberId: this.$store.getters.loginUserInfo.staff_id,
        geolocation: {
          lat: this.mGeoLocation.lat,
          lon: this.mGeoLocation.lon,
          msg: this.mPosMsg,
          send_time: send_datetime,
        },
      }

      const result = await this.$store.dispatch('aUpdateGeoLocation', sendData)
      if (result.error || result.body.error) {
        this.$refs.errorDialogSend.$emit('show')
      }
      else {
        this.$refs.infoDialogSend.$emit('show')
      }
    },
    // -------------------------------------------------------------------------
    getGeoLocation: async function () {
      const locate = await getGeoLocation(this.$store.getters.isMobile, this.$store.getters.isGnssReady)
      if (locate.result === 'ng') {
        this.mWarningMsg = locate.alertMsg
        this.$refs.warningDialog.$emit('show')
      }
      else {
        this.$refs.mapobj.setMarker(this.mMapZoom, Number(locate.lon), Number(locate.lat))
        locate.lon = Number(locate.lon).toFixed(5)
        locate.lat = Number(locate.lat).toFixed(5)
      }
      this.mGeoLocation.lat = locate.lat
      this.mGeoLocation.lon = locate.lon
    }
  }
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
.hm-map-area {
  width: 95%;
  height: 35vh;
  margin: 10px auto;
}
.hm-mld-databox {
  margin-top: 20px;
  margin-bottom: 0px;
}
.hm-mld-msgbox {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialogs/MapLocationDialog.vue